import { useEffect, useState } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

const MINIMUM_LOADING_TIME = 500

const Loading = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setVisible(true)
    }, MINIMUM_LOADING_TIME)
    return () => clearTimeout(timeoutId)
  }, [])

  if (!visible) {
    return null
  }

  return (
    <Box justifyContent="center" alignItems="center" paddingY="s48">
      <Spinner />
    </Box>
  )
}

export default Loading
